import { Artist } from '../../types/artist'
import { formatNumber } from '../../utils'
import styles from './Artists.module.css'

interface ArtistGridProps {
  artists: Artist[]
  onArtistClick?: (artist: Artist) => void
}

export function ArtistGrid({ artists, onArtistClick }: ArtistGridProps) {
  const unique = Array.from(new Map(artists.map(a => [a.id, a])).values())
  return (
    <div className={styles.artistGrid}>
      {unique.map(artist => (
        <ArtistCard
          key={`artist-${artist.id}`}
          artist={artist}
          onClick={onArtistClick}
        />
      ))}
    </div>
  )
}

interface ArtistCardProps {
  artist: Artist
  onClick?: (artist: Artist) => void
}

function ArtistCard({ artist, onClick }: ArtistCardProps) {
  return (
    <div className={styles.artistCard} onClick={() => onClick?.(artist)}>
      <div className={styles.artistAvatar}>
        {artist.cover_image ? (
          <img src={artist.cover_image} alt={artist.name} />
        ) : (
          <div className={styles.artistNoImage}>
            <i className="bi bi-person-fill"></i>
          </div>
        )}
      </div>

      <div className={styles.artistContent}>
        <div className={styles.artistName}>{artist.name}</div>
        {artist.alias_names && (
          <div className={styles.artistAliases} title={artist.alias_names}>
            aka {artist.alias_names}
          </div>
        )}
        <div className={styles.artistMeta}>
          {formatNumber(artist.release_count)} release{artist.release_count !== 1 ? 's' : ''}
        </div>
      </div>
    </div>
  )
}
